module.exports = __webpack_public_path__ + "img/appAsset--automation-ax.aa9b1b91.svg";